<template>
<div v-if="themes">
	<div v-if="themes.length > 0">
		<table class="table--fixed table-navigation">
			<thead>
				<tr>
					<th class="question-cell">{{ 'theme' | translate | titleCase }}</th>
					<th class="supporters-cell">{{ 'supporters' | translate | titleCase }}</th>
				</tr>
			</thead>
			<tfoot v-if="themes.length > 10">
				<tr>
					<th class="question-cell">{{ 'theme' | translate | titleCase }}</th>
					<th class="supporters-cell">{{ 'supporters' | translate | titleCase }}</th>
				</tr>
			</tfoot>
			<tbody >
				<tr class="line" v-for="theme in themes" :key="theme.id">
					<td :title="'theme' | translate" class="question-cell" @click="detailsTheme(theme.id)">{{ theme.tag }}</td>
					<td :title="'supporters' | translate" class="supporters-cell"> <router-link :to="'tema?id=' + (theme.id)"> <i class="fas fa-user"></i> {{ theme.recipient_count }}</router-link> </td>
				</tr>
			</tbody>
		</table>
	</div>
	<div v-else>
		<p class="empty-state">
			{{ 'no-positioning' | translate | capitalize }}
		</p>
	</div>
</div>
</template>
<script>
export default {
	name: 'pendingThemes',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			issues: {},
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
		themes() {
			return (this.$store.state.entity.pendingThemes || []).politician_entities || [];
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
		detailsTheme(id) {
			this.$router.push({ name: 'knowledgeDetails', query: { id } });
		},
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/entity/pendingThemes.vue